import React from 'react'
import SubHeader from '../general/SubHeader';
import AboutImg from '../assets/about-img.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';

const About = () => {
  return (
    <>
      <SubHeader message='About Us' />

{/* About section */}
<section className='bg-light py-5'>
    <div className='container'>


<div className='row'>

<div className='col-lg-6 col-12 my-2'>
<img src={AboutImg} className='img-fluid' alt='About' />
</div>

<div className='col-lg-6 col-12 my-2 align-content-center'>
              <p className='sec-subheading my-0'>About</p>
          <p className='sec-heading'>Discover Top Destinations With Us</p>
          <p>Shakti Tour & Travels specializes in crafting unforgettable journeys with expert guidance, budget-friendly packages, scenic adventures, and personalized travel experiences across stunning destinations.
            We have professional tour guides ensure safe, informative, and enriching journeys.
          </p>
          <p><i class="fa-solid me-3 text-orange fa-circle-check"></i>Customized Packages<br />
<i class="fa-solid me-3 text-orange fa-circle-check"></i>Expert Guidance<br />
<i class="fa-solid me-3 text-orange fa-circle-check"></i>Affordable Pricing          </p>

</div>

</div>
{/* row ends */}

    </div>
</section>
{/* About section ends */}

      {/* Testimonial section */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-subheading'>Testimonials</p>
          <p className='sec-heading'>What our Clients are Saying</p>

          <Swiper spaceBetween={30} slidesPerView={3} modules={[Autoplay, Navigation]} loop={true} className='py-3 px-md-5 px-2'
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              }
            }}>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>Shakti Tours made our vacation perfect—great planning, beautiful spots, and attentive service throughout the journey.</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>The guides were knowledgeable and friendly. Every detail was taken care of. Truly a stress-free vacation experience.</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>From scenic treks to cozy stays, Shakti Tours delivered an amazing mix of thrill and comfort making our holidays worthy.</p>
              </div>
            </SwiperSlide>


            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>Our custom tour package was perfect. Everything ran smoothly, and the team was always just a call away.</p>
              </div>
            </SwiperSlide>

          </Swiper>


        </div>
      </section>
      {/* Testimonial section ends */}


    </>
  )
}

export default About
